import script from "./CalculationItemDetailList.vue?vue&type=script&setup=true&lang=js"
export * from "./CalculationItemDetailList.vue?vue&type=script&setup=true&lang=js"

import "./CalculationItemDetailList.vue?vue&type=style&index=0&id=2e25ee60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e25ee60"]])

export default __exports__